export const ADTLogo = ({ ...props }: IconProps) => {
  return (
    <svg
      data-testid="adt-logo"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      fill="none"
      {...props}>
      <g id="Logo">
        <path
          id="Octagon-Body"
          d="M14.064 0L0 14.054V33.946L14.064 48H33.936L48 33.946V14.054L33.936 0H14.064Z"
          fill="#0061AA"
        />
        <path
          id="ADT"
          d="M33.161 31.7579V19.6039H28.578V16.2859H41.178V19.6039H36.553V31.7579H33.161ZM23.337 31.7579L23.196 31.4829L19.349 23.9499V16.2419H24.623C25.7762 16.234 26.918 16.4695 27.974 16.9329V20.2079H31.513C32.1292 21.3721 32.4451 22.6717 32.432 23.9889C32.4483 25.0177 32.2594 26.0395 31.8763 26.9944C31.4933 27.9494 30.9237 28.8185 30.201 29.5509C29.4618 30.2671 28.5887 30.8307 27.6316 31.2094C26.6745 31.5881 25.6522 31.7744 24.623 31.7579H23.337ZM22.737 28.3579H24.623C25.2068 28.3889 25.7906 28.2976 26.3371 28.09C26.8836 27.8824 27.3807 27.5629 27.7966 27.1522C28.2126 26.7414 28.5382 26.2483 28.7526 25.7045C28.9671 25.1606 29.0656 24.578 29.042 23.9939C29.0665 23.4093 28.9686 22.826 28.7545 22.2814C28.5405 21.7369 28.215 21.2431 27.7989 20.8316C27.3829 20.4202 26.8855 20.1002 26.3385 19.8923C25.7916 19.6843 25.2073 19.5929 24.623 19.6239H22.739L22.737 28.3579ZM18.185 30.1719H11.317L10.491 31.7579H6.823L14.751 16.2789L22.657 31.7559H18.991L18.185 30.1719ZM12.949 26.9579H16.531L14.751 23.4689L12.949 26.9579Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
